import {
  FiArrowUpRight,
  FiCheckCircle,
  FiLayers,
  FiXCircle,
} from 'react-icons/fi'
import {
  Box,
  Button,
  HStack,
  Link,
  Spinner,
  Text,
  Tooltip,
  VStack,
} from '@chakra-ui/react'
import { ITransaction, TransactionStatus } from 'types'
import { FormatDate, formatDate, getDateFromNow } from 'utils/date/dateFormat'
import { formatBlockExplorerLink } from 'utils/web3'

const Transaction = ({
  txHash,
  chainId,
  status,
  name,
  addedTime,
  confirmedTime,
}: ITransaction) => (
  <HStack justifyContent="space-between" alignItems="center">
    <VStack alignItems="flex-start">
      <Button
        as={Link}
        isExternal
        variant="link"
        _focus={{ outline: 'none' }}
        color="#8f96ac"
        href={formatBlockExplorerLink('tx', [chainId, txHash])}
      >
        <Text pr={1}>{name}</Text>
        <FiArrowUpRight />
      </Button>
      {!!confirmedTime && (
        <Text color="muted" fontSize="sm">
          {formatDate(confirmedTime || addedTime, FormatDate.Short)}
          {' - '}
          {getDateFromNow(confirmedTime || addedTime)}
        </Text>
      )}
    </VStack>
    {status === TransactionStatus.confirmed ? (
      <Tooltip label="Mined transaction" hasArrow placement="right">
        <Box>
          <FiCheckCircle color="green" size="24px" />
        </Box>
      </Tooltip>
    ) : status === TransactionStatus.failed ? (
      <Tooltip label="Reverted transaction" hasArrow placement="right">
        <Box>
          <FiXCircle color="#d74380" size="24px" />
        </Box>
      </Tooltip>
    ) : status === TransactionStatus.dropped ? (
      <Tooltip
        label="Dropped or replaced transaction"
        hasArrow
        placement="right"
      >
        <Box>
          <FiLayers color="#c792ea" size="24px" />
        </Box>
      </Tooltip>
    ) : (
      <Spinner size="md" color="#2172e5" />
    )}
  </HStack>
)

export default Transaction
